export default __webpack_public_path__ + "static/media/warning_yellow.69559c04.svg";